import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { mapStateToProps } from "../../../redux/reducers";
import { connect } from "react-redux";
import * as actionType from "../../../redux/actionTypes/csaSignup";
import {
  Grid,
  Button,
  Typography, Box,
  Link
} from "@mui/material";
import { Row, Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { maskMobile, popUpAlert } from '../../../utils/globalMethods';
import { useParams  } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { Info } from '@mui/icons-material';
import { lang } from 'moment';




function ClientInfoComponent(props) {
  let { agreementId, vendorId,clientId } = useParams(); 

  const [clientInfo, setClientInfo] = useState(props?.clientInfo);
  // eslint-disable-next-line no-unused-vars 
  const [firstName, setFirstName] = useState("")
  // eslint-disable-next-line no-unused-vars 
  const [lastName, setLastName] = useState("");
  // eslint-disable-next-line no-unused-vars 
  const [chosenNam, setChosenNam] = useState("");
  // eslint-disable-next-line no-unused-vars 
  const [email, setEmail] = useState("")
  // eslint-disable-next-line no-unused-vars 
  const [day, setDay] = useState("");
  // eslint-disable-next-line no-unused-vars 
  const [month, setMonth] = useState("");
  // eslint-disable-next-line no-unused-vars 
  const [year, setYear] = useState("");
  const [language, setLanguage] = useState({});
  const [showContent, setShowContent] = useState('');
  const [isEdit, setIsEdit] = useState(true);
  const [isNext, setIsNext] = useState(false);
  const [formattedValue, setFormattedValue] = useState(''); //(342) 342-3432
  const [isPartialSignup, setIsPartialSignup] = useState(false);
  const [formData, setFormData] = useState();
  const [yearError, setYearError] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState();
  
  // const isNumber = (e) => /^[0-9]+$/.test(e.key);
  const {
    register,
    handleSubmit,
    getValues,
    reset,setValue,
    formState: { errors }
  } = useForm();
  const currentYear = new Date().getFullYear();

  const userRole = props?.userAuth?.user ? props?.userAuth?.user : JSON.parse(sessionStorage.getItem("userData"));
  useEffect(() => {
    setLanguage(props.signupLanguage)
  }, [props.signupLanguage]);

  useEffect(() => {
    if (getValues()?.ebt) {
      setMessage(getValues()?.ebt === "EBT card" ? language.ebtCard : language.agencyId);
    } else if (clientInfo?.ebt) {
      setMessage(clientInfo?.ebt === "EBT card" ? language.ebtCard : language.agencyId);
    }
  }, [language]);

  useEffect(() => {
    if (isNext || isPartialSignup) {
      if (props?.csaSignup?.clientInfo?.clientInfo?.code) {
        setClientInfo({});

        let message = props?.csaSignup?.clientInfo?.clientInfo?.message;
        if( message === "Invalid First Name or Last Name or Date of Birth" ) {
           message = "Invalid First Name, Last Name and Date of Birth"
        } else if ( message === "Invalid First Name or Last Name" ) {
           message = "Invalid First Name and Last Name"
        } else if ( message === "Invalid First Name or Date of Birth" ) {
           message = "Invalid First Name and Date of Birth"
        } else if (message === "Invalid Last Name or Date of Birth") {
           message = "Invalid Last Name and Date of Birth"
        }

        popUpAlert({
          title: "Error",
          text: message,
          icon: "error",
          showCancelButton: false,
          showConfirmButton: true,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "OK",
          closeOnConfirm: false,
          onConfirmed: true,
        });
      } else {
        const clientInfo = props?.csaSignup?.clientInfo?.clientInfo;
        clientInfo.phoneno = formData?.phoneno ? formData?.phoneno : setFormattedValue(maskMobile(clientInfo?.phoneNumber));
        setClientInfo(clientInfo);
        if (Object.keys(clientInfo).length) {
          const clientData = {
            "apid": clientInfo?.apid,
            "apiId": formData?.apiId ? formData?.apiId : clientInfo?.apid,
            "dob": clientInfo?.dob,
            "email": clientInfo?.clientPreferdEmail ? clientInfo?.clientPreferdEmail : (formData?.email ? formData?.email : clientInfo?.email),
            "firstName": formData?.firstName ? formData?.firstName : clientInfo?.firstName,
            "hhSize": clientInfo?.hhSize,
            "lastName": formData?.lastName ? formData?.lastName :clientInfo?.lastName,
            "chosenNam": formData?.chosenNam ? formData?.chosenNam : clientInfo?.chosenNam,
            "clientPreferdEmail": clientInfo?.clientPreferdEmail ? clientInfo?.clientPreferdEmail : (formData?.email ? formData?.email : clientInfo?.email),
            "clientPreferdPhone": clientInfo?.clientPreferdPhone ? clientInfo?.clientPreferdPhone?.replace(/\D/g, '') : (formData?.phoneno ? formData?.phoneno?.replace(/\D/g, '') : clientInfo?.phoneNumber.replace(/\D/g, '')),
            "panNumber": clientInfo?.panNumber,
            "phoneNumber": clientInfo?.clientPreferdPhone ? clientInfo?.clientPreferdPhone : (formData?.phoneno ? formData?.phoneno : clientInfo?.phoneNumber),
            "snapAmount": clientInfo?.snapAmount,
            "hipAmount": clientInfo?.hipAmount,
            "ebtCardBalance": clientInfo?.ebtCardBalance,
            "ebtCardBalanceAsOfDate": clientInfo?.ebtCardBalanceAsOfDate,
            "ebt": formData?.ebt,
            "day": formData?.day ? formData?.day : (clientInfo?.dob? clientInfo?.dob.split("-")[2] : ""),
            "month": formData?.month ? formData?.month :(clientInfo?.dob? parseInt(clientInfo?.dob.split("-")[1]) : ""),
            "year": formData?.year ? formData?.year : (clientInfo?.dob? clientInfo?.dob.split("-")[0] : ""),
            "phoneno": clientInfo?.clientPreferdPhone ? setFormattedValue(maskMobile(clientInfo?.clientPreferdPhone)) : (formData?.phoneno ? formData?.phoneno : (clientInfo?.phoneNumber ? setFormattedValue(maskMobile(clientInfo?.phoneNumber)) : "")), // formData?.phoneno ? formData?.phoneno : setFormattedValue(maskMobile(clientInfo?.phoneNumber))
          }
          if (!formData?.ebt) {
            clientData.ebt = "DTA agency";
            clientData.apiId = clientInfo?.apid;
          }

          reset(clientData);
          // setShowContent(clientInfo?.apid === clientInfo?.clientId ? "DTA agency" : "EBT card");
          // if (showContent === 'EBT card') {
  //   message = "EBT Card Number"
  // }
  // else if (showContent === "DTA agency") {
  //   message = "DTA Agency ID"
  // }
          setShowContent(clientData.ebt);
          setMessage(clientData.ebt === "EBT card" ? language.ebtCard : language.agencyId);
          props.setClientInfo(clientData);
          props.setCSAFormValidate((prevState) => ({
            ...prevState,
            client_info: true
          }));
          if (isNext) {
            props.setActiveTab("menuStep3"); 
          }
        } 
      }
    }
  }, [props?.csaSignup?.clientInfo]);



  useEffect(()=>{
    if (clientId && !clientInfo) {
      const obj = {
        apid:clientId,
        isPartialSignup:true,
        agreementId,
        vendorId
      }
      props.getClientInfo(obj);
      setIsPartialSignup(true);
    } else {
      if (clientInfo) {
        clientInfo?.phoneno ? 
          setFormattedValue(maskMobile(clientInfo?.phoneno)) 
          : setFormattedValue(maskMobile(clientInfo?.phoneNumber));
        reset(clientInfo);
      }
    }
  },[clientId]); 

  useEffect(()=>{
    if (clientInfo) {
      setShowContent(getValues()?.ebt ? getValues()?.ebt : clientInfo?.ebt);
      if (getValues()?.ebt) {
        setMessage(getValues()?.ebt === "EBT card" ? language.ebtCard : language.agencyId);
      } else if (clientInfo?.ebt) {
        setMessage(clientInfo?.ebt === "EBT card" ? language.ebtCard : language.agencyId);
      }
    }
  },[clientInfo]);

  const handleButtonClick = (data) => {
    const { firstName, lastName, ebt } = data;
    const trimmedFirstName = firstName.trim();
    const trimmedLastName = lastName.trim();
    const trimmedEbt = (ebt ? ebt.trim() : showContent.trim());
    setFormData(data);
    setIsNext(true);
    const dob = data.year + '-' + (data.month < 10 ? '0' + data.month : data.month) + '-' + (data?.day?.length < 2 ? '0' + data.day : data.day);
    // const { firstName, lastName, ebt } = data;
    const newData = {
      firstName: trimmedFirstName,
      lastName: trimmedLastName,
      dob,
      apid: trimmedEbt === "DTA agency" ? data.apiId : null,
      panNumber: trimmedEbt === "EBT card" ? "600875" + data.apiId : null,
      isAdmin : userRole.Role === "ADMIN" ? true : false  
    };
    props.getClientInfo(newData);   
  }

  const handleRadioChange = (e) => {
    setShowContent(e.target.value.trim());
    setMessage(e.target.value.trim() === "EBT card" ? language.ebtCard : language.agencyId);
    setValue("apiId", "");
    setIsEdit(true);
  };

  // let message = ''
  // if (showContent === 'EBT card') {
  //   message = "EBT Card Number"
  // }
  // else if (showContent === "DTA agency") {
  //   message = "DTA Agency ID"
  // }


  const handleYearChange = (e) => {
    let value = e.target.value.trim();
    
    if (parseInt(value, 10) >= currentYear) {
      setYearError(language.validYearError)
      setYear('');
    } else {
      setYearError('');
      setYear(value);
    }
  };
  const handleChange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^0+/, '');

    if (inputValue !== '') {
      const intValue = parseInt(inputValue, 10);
      if (!isNaN(intValue) && intValue >= 1 && intValue <= 31) {
        inputValue = intValue < 10 ? `0${intValue}` : `${intValue}`;
        setError('');
      } else {
        setError(language.validDayError);
        inputValue = '';
      }
    }
    setDay(inputValue);
  };

  return (
    <Form onSubmit={handleSubmit(handleButtonClick)}  >
      <Grid item lg={12} md={12} ml={4} className='wrapper-gird' sx={{ mt: 7.2, border: '1px solid #CCCCCC'}}>
        <Box sx={{ backgroundColor: '#EEEEEE', borderBottom: '1px solid #CCCCCC' }}>
          <Typography variant="h3" xs={{ fontFamily: "texta-bold" }} className='sub-heading' tabIndex={0}>
            {language.clientInfo}
          </Typography>
        </Box>        
        <div style={{ padding: '20px' }} id="client-info">
          <p style={{paddingBottom: '10px'}}>Fields marked with a asterisk <span className="ads-asterisk" aria-hidden="true">*</span> are required.</p>
          <Row className="mb-3">
            <Col xs={12} md={6} lg={5}>
              <Form.Label className="firstName" htmlFor='firstName'>
                {language.firstName} 
                <span aria-hidden="true">*</span>
              </Form.Label>
              <Form.Control
                style={{ border: '1px solid #adb5bd'}}
                className='first-textfield'
                type="text"
                id='firstName'                
                {...register("firstName", { required: language.signupFirstNameError })}
                defaultValue={clientInfo?.firstName ? clientInfo?.firstName : ''}  
                autoComplete="off"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^A-Za-z\s'-]/g, '');
                  e.target.value = value;
                  setFirstName(value);
                }}
                maxLength={15}
              />
              {errors.firstName  && (
                  <span className="dh-txt-danger" role="alert" aria-live="assertive">
                    {errors.firstName.message}
                  </span>
                )}
            </Col>
            <Col xs={12} md={6} lg={5}>
              <Form.Label className="lastName" htmlFor="lastName">
                {language.lastName}
                <span aria-hidden="true">*</span>
              </Form.Label>
              <Form.Control
                style={{ border: '1px solid #adb5bd'}}
                className='last-textfield custom-input'
                type="text"
                id="lastName"  
                              
                {...register("lastName", { required: language.signupLastNameError})}
                defaultValue={clientInfo?.lastName ? clientInfo?.lastName :''}
                autoComplete="off"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^A-Za-z\s'-]/g, '');
                  e.target.value = value;
                  setLastName(value);
                }}
                maxLength={20}
              />
              {errors.lastName && (
                <span className="dh-txt-danger" role="alert" aria-live="assertive">
                  {errors.lastName.message}
                </span>
                )}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={12} md={6} lg={5}style={{ marginTop: '20px' }}>
              <Form.Label className="chosenName" htmlFor="chosenNam" >
                {language.chosenName} <Tooltip title={language.preferNameMoreInfo}  placement="top"><IconButton><Info/></IconButton></Tooltip>
              </Form.Label>
              <Form.Control
                style={{ border: '1px solid #adb5bd'}}
                className='Chosen-textfield'
                type="text"
                id="chosenNam"
                {...register("chosenNam")}
                defaultValue={clientInfo?.chosenNam ? clientInfo?.chosenNam : ''}
                autoComplete="off"
                onChange={(e) => setChosenNam(e.target.value)}
                maxLength={50}
                // style={{ fontSize: "12px" }}
              />
            </Col>
            <Col xs={12} md={6} lg={5} style={{ marginTop: '20px' }} >
              <Form.Label className="DateOfBirth" aria-label='date Of birth'>
                {language.dateOfBirth} <span className="sr-only">required</span><span aria-hidden="true">*</span>
                </Form.Label>
              <Row style={{ paddingTop:'0.8rem' }}>
                
                <Col md={5}>
                  {/* <Form.Label className="DateOfBirth">
                    Month*
                  </Form.Label> */}
                  <Form.Select
                    className="clearArrowSelect"
                    
                    aria-label='month of birth'
                    style={{ height: '43px',border: '1px solid #adb5bd', fontSize: '1.20rem' }}
                    defaultValue={clientInfo?.month ? clientInfo?.month : ''}
                    autoComplete="off"
                    {...register("month", { required: true })}
                    onChange={(e) => { setMonth(e.target.value)}}
                  >
                    <option value="">{language.month}</option>
                    <option value="1">{language.January}</option>
                    <option value="2">{language.February}</option>
                    <option value="3">{language.March}</option>
                    <option value="4">{language.April}</option>
                    <option value="5">{language.May}</option>
                    <option value="6">{language.June}</option>
                    <option value="7">{language.July}</option>
                    <option value="8">{language.August}</option>
                    <option value="9">{language.September}</option>
                    <option value="10">{language.October}</option>
                    <option value="11">{language.November}</option>
                    <option value="12">{language.December}</option>
                  </Form.Select>
                </Col>
                <Col md={3}>
                  {/* <Form.Label className="DateOfBirth">
                    Day*
                  </Form.Label> */}
                  <Form.Control className='formControl' type="text" placeholder={language.day}
                  style={{ border: '1px solid #adb5bd'}}
                  aria-label='day of birth'
                  
                    {...register("day", { required: true })}
                    // onKeyDown={isNumber}
                    onKeyPress={(e) => {
                      if(e.key < "0" || e.key > "9") {
                        e.preventDefault();
                      }
                    }}
                    maxLength={2}
                    defaultValue={clientInfo?.day ? clientInfo?.day : ''}
                    autoComplete="off"
                    // onChange={(e) => setDay(e.target.value.trim())}
                    onChange={handleChange}
                  />
                </Col>
                <Col md={4}>
                  {/* <Form.Label className="DateOfBirth">
                    Year*
                  </Form.Label> */}
                  <Form.Control
                    style={{ border: '1px solid #adb5bd'}}
                    className='formcontrol-year'
                    type="text"
                    aria-label='year of birth'
                    
                    autoComplete="off"
                    placeholder={language.year}
                    {...register("year", { required: true })}
                    // onKeyDown={isNumber}
                    onKeyPress={(e) => {
                      if(e.key < "0" || e.key > "9") {
                        e.preventDefault();
                      }
                    }}
                    maxLength={4}
                    defaultValue={clientInfo?.year ?clientInfo?.year : ""}
                    onChange={handleYearChange}
                  />
                </Col>
              {/* </Row> */}
              </Row>
              {(errors.day || errors.month || errors.year) && 
                    (<span className="dh-txt-danger" role="alert" aria-live="assertive">{language.signupDateOfBirthError}</span>)
                }
                {error && <span className='dh-txt-danger' >{error}</span>}
              {yearError && (
                 <span className='dh-txt-danger' >{yearError}</span>
                   )}
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={12} md={6} lg={5} style={{ margin: '10px 0px' }}>
              <fieldset className="EbtDta" htmlFor='ebt-card'>
                {language.ebtCardAgencyId} <span className="sr-only">required</span><span aria-hidden="true">*</span>
              </fieldset>
              <Row>
                <Col xs={12} md={6} lg={7} xl={6}>
                  <Form.Check
                    type="radio"
                    name="ebt"
                    id="ebt-card"
                    value="EBT card"
                    {...register("ebt", { required: true })}
                    label={language.ebtCard}
                    //checked={showContent === 'EBT card'}
                    onChange={handleRadioChange}
                    className='custom-radio'
                    //defaultChecked={clientInfo?.panNumber ? clientInfo?.panNumber : ''}
                  />
                </Col>
                <Col  xs={12} md={6} lg={7} xl={6}>
                  <Form.Check
                    type="radio"
                    name="ebt"
                    id="dta-agency"
                    value="DTA agency"
                    label={language.agencyId}
                    {...register("ebt", { required: true })}
                    //checked={showContent === 'DTA agency'}
                    onChange={handleRadioChange}
                    className='custom-radio'
                    //defaultChecked={ clientInfo?.clientId ? clientInfo?.clientId : ''}
                  />
                </Col>
                {errors.ebt && (
                  <span className='dh-txt-danger'  role="alert" aria-live="assertive">Please enter EBT Card Number / DTA Agency ID</span>
                )}
              </Row>

            </Col>
            {showContent === 'DTA agency' && (
              <Col xs={12} md={6} lg={5}>
              <Form.Label className='ebtCard' htmlFor='apId'>
                {message} <span aria-hidden="true">*</span>
              </Form.Label>
              <div className='cardName ebt-wrapper'>
                <Form.Control
                  type="text"
                  name="apiId"
                  id = "apId"
                  
                  className='agency'
                  {...register("apiId", { required: true })}
                  maxLength={7}
                  onKeyPress={(e) => {
                    if(e.key < "0" || e.key > "9") {
                      e.preventDefault();
                    }
                  }}
                  disabled={!isEdit}
                  //defaultValue= {clientInfo?.clientId ? clientInfo?.clientId : (clientInfo?.panNumber ? clientInfo?.panNumber : (showContent === "DTA agency" ? "": ""))} //{showContent === "DTA agency" ? 6455326 : ""}
                />
              </div>
                { message && errors.apiId && (
                  <span className='dh-txt-danger'  role="alert" aria-live="assertive">{message === language.agencyId ? language.signupAgencyIdError : language.signupEBTCardError}</span>
                )} 
            </Col>
            )}
            {showContent === 'EBT card' && (
            <Col xs={12} md={6} lg={5}>
              <Form.Label className='ebtCard' htmlFor='apId'>
                {message} <span aria-hidden="true">*</span>
              </Form.Label>
              <div className='cardName ebt-wrapper'>
                <div style={{ width: '4.5rem' }}><span>{600875}</span></div>
                <Form.Control
                  type="text"
                  name="apiId"
                  id = "apId"                  
                  className='ebt'
                  {...register("apiId", { required: true })}
                  maxLength={12}
                  onKeyPress={(e) => {
                    if(e.key < "0" || e.key > "9") {
                      e.preventDefault();
                    }
                  }}
                  disabled={!isEdit}
                  //defaultValue= {clientInfo?.clientId ? clientInfo?.clientId : (clientInfo?.panNumber ? clientInfo?.panNumber : (showContent === "DTA agency" ? "": ""))} //{showContent === "DTA agency" ? 6455326 : ""}
                />
              </div>
                { message && errors.apiId && (
                  <span className='dh-txt-danger'  role="alert" aria-live="assertive">{message === language.agencyId ? language.signupAgencyIdError : language.signupEBTCardError}</span>
                )} 
            </Col>
            )}
          </Row>
          <Row className="mb-3" >
            <Col xs={12} md={6} lg={5}>
              <Form.Label className="email " htmlFor="email">
                {language.email}
              </Form.Label>
              <Form.Control
                style={{ border: '1px solid #adb5bd'}}
                className="email-textfield lowercase"
                type="text"
                id="email"
                {...register("email",{
                  pattern: {
                    value:
                        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid Email format",
                },
                })}
                onChange={(e) => { setEmail(e.target.value.toLowerCase().trim()) }}
                defaultValue={clientInfo?.clientPreferdEmail ? clientInfo?.clientPreferdEmail : ""}
                autoComplete="off"
                maxLength={350}
              />
               {errors.email && (
                  <span className="dh-txt-danger" >
                      {errors.email.message}
                  </span>
                    )}
            </Col>
            <Col xs={12} md={6} lg={5}>
              <Form.Label className="phoneno" htmlFor='phoneno'>
                {language.phone} <span aria-hidden="true">*</span>
              </Form.Label>
              <Form.Control
                style={{ border: '1px solid #adb5bd'}}
                className="phoneNo-textField "
                id='phoneno'
                
                {...register("phoneno", {
                  required:true,
                  pattern: {
                      value:
                          /^\s*[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})\s*$/,
                      message: "Invalid Phone number",
                  },
              })}
                type="Text"
                placeholder="(___) ___-____"
                // onChange={handleChange}
                value={formattedValue}
                onChange={(e) =>{
                    setFormattedValue(maskMobile(e.target.value));
                }}
                defaultValue={clientInfo?.phoneno ? clientInfo?.phoneno : formattedValue}
                autoComplete="off"
              />
                {errors.phoneno && (
                <span className='dh-txt-danger' role="alert" aria-live="assertive">
                  {language.signupPhoneError}
                </span>
              )}
            </Col>
          </Row>
            <Row>
              <Col  xs={12} md={12} lg={10} className='alert alert-success moretext' id="dtaConnectInfo">
                <i className="fa fa-info-circle" aria-hidden="true"></i>{" "}
               {language.contactInfoMoreInfo} 
               <a aria-describedby="dtaConnectInfo" href="https://dtaconnect.eohhs.mass.gov/" target="_blank" rel="noopener noreferrer">www.DTAConnect.com</a>.               
              </Col>
            </Row>
        </div>

        <Grid container direction="row" justifyContent="flex-end" sx={{ border: '1px solid rgba(0, 0, 0, 0.125)', borderTop: 'none', backgroundColor: "#EEEEEE", height: '80px' }}>
          <Box sx={{ padding: '10px', background: '#eeeeee', borderTop: 'none', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', height: '80px' }}>
            <Button aria-label="previous" onClick={() => {
              props.setActiveTab("menuStep1");
              props.setClientInfo(getValues()); 
            }} sx={{
              backgroundColor: '#ffffff', color: '#006E52', height: '50px', width: '100px', borderColor: '#006E52', border: 'solid', borderWidth: '1px', textTransform: 'none', '&:hover': {
                backgroundColor: '#006E52',
                color: '#ffffff',
              },
              '&:focus-visible': {
                      outline: '2px solid white',   
                      outlineOffset: '2px',
                      boxShadow: '0 0 0 4px black', 
              },
              '&:active': {
                backgroundColor: '#006E52',
                color: '#ffffff',
              },
            }}>
              <ArrowBackIosNewIcon /> {language.Prev}
            </Button>
            <Button
              sx={{ backgroundColor: '#006E52 !important', color: 'white', height: '50px', width: '120px', textTransform: 'none', marginLeft: '10px',
                    '&:focus-visible': {
                      outline: '2px solid white',   
                      outlineOffset: '2px',
                      boxShadow: '0 0 0 4px black', 
                    }
               }}
              type="submit" value="Submit" > {language.Next} <ArrowForwardIosIcon /></Button>
          </Box>
        </Grid>
      </Grid >
    </Form >
  );
}

ClientInfoComponent.propTypes = {
  setActiveTab: PropTypes.func.isRequired,
  getClientInfo: PropTypes.func.isRequired,
  csaSignup: PropTypes.object.isRequired,
  activeMenu: PropTypes.object,
  handleUpdate: PropTypes.func,
  setCSAFormValidate: PropTypes.func.isRequired,
  clientInfo: PropTypes.object,
  setClientInfo: PropTypes.func,
  userAuth: PropTypes.object.isRequired,
  signupLanguage: PropTypes.object,
}

function mapDispatchToProps(dispatch) {
  return {
    getClientInfo: (payload) => dispatch(actionType.getClientInfo(payload)),
    getSnapHipAmount: (payload) => dispatch(actionType.getSnapHipAmount(payload))
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClientInfoComponent);